import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const contactMessageSchema = z.object({
  fullName: z.string().trim().min(2, "Merci d'indiquer votre nom complet.").max(120),
  phone: z
    .string()
    .trim()
    .regex(/^(?:\+212|0)\s?[5-7](?:[\s.-]?\d{2}){4}$/, "Merci d'indiquer un numéro de téléphone marocain valide."),
  email: z.string().trim().email("Adresse e-mail invalide.").max(160).optional().or(z.literal("")),
  subject: z.enum(["Ma commande", "Livraison", "Échange / retour", "Taille / produit", "Autre"]),
  message: z.string().trim().min(10, "Merci de détailler votre demande (10 caractères minimum).").max(2000),
});

export type ContactMessageInput = z.infer<typeof contactMessageSchema>;

/** Enregistre un message de contact dans la base (consultable côté serveur). */
export const sendContactMessage = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => contactMessageSchema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { error } = await supabaseAdmin.from("contact_messages").insert({
      full_name: data.fullName,
      phone: data.phone,
      email: data.email ? data.email : null,
      subject: data.subject,
      message: data.message,
    });

    if (error) throw new Error("Envoi impossible pour le moment. Merci de réessayer dans quelques instants.");

    return { ok: true as const };
  });
